export const mixinpage = {
    data() {
        return {
            infodata: {},
            isload: false
        };
    },
    props: {
        parpage: {
            type: Object,
            default: () => {
                return {
                    pname: 'home',
                    ptitle: '',
                    id: 0
                }
            }
        }
    },
    computed: {
        parglobal: function () {
            return this.$store.state.parglobal;
        }
    },
    methods: {
        gopage: function (goname, id = 0) {
            let _parpage = { id: id || 0, title: '', pname: '' };
            let ischeck = true;
            switch (goname) {
                case 'login':
                    switch (id) {
                        case 0:
                            _parpage.title = '会员登录';
                            break;
                        case 1:
                            _parpage.title = '会员注册';
                            break;
                        case 2:
                            _parpage.title = '找回密码';
                            break;
                    }
                    break;
                case 'profile':
                    ischeck = this.checklogin();
                    _parpage.title = id == 1 ? '个人信息编辑' : '个人信息';
                    break;
                case 'infodetail':
                    _parpage.title = '信息详细';
                    break;
                case 'infoedit':
                    ischeck = this.checklogin();
                    _parpage.title = '发起投诉';
                    break;
                case 'terms':
                    _parpage.title = '注册条款';
                    break;
            }
            _parpage.pname = goname;
            if (ischeck) {
                this.$emit('update:parpage', _parpage);
            }


        },
        gopagesub: function (id) {
            this.gopage(this.parpage.pname, id);
        },
        checklogin: function () {
            if (!this.$store.state.islogin) {
                this.gopage('login');
                return false;
            }
            return true;
        }
    }
}
